// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subticket-box {
  width: 100%;
  padding: 15px;
  border: 5px solid aliceblue;
  margin: 5px;
  border-radius: 10px;
}

.contrast {
  color: white;
  border-radius: 5px;
}

.list-scroll {
  height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/todo-assist/todo-assist.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;AACJ","sourcesContent":[".subticket-box {\n    width: 100%;\n    padding: 15px;\n    border: 5px solid aliceblue;\n    margin: 5px;\n    border-radius: 10px; \n}\n\n.contrast {\n    color: white;\n    border-radius: 5px;\n}\n\n.list-scroll {\n    height: 600px; \n    overflow-y: auto; \n    overflow-x: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
